import React from "react";
import { useLocation } from "react-router-dom";

import { Box } from "@chakra-ui/react";

import { Journey } from "models/Journey";

import TripCard from "./TripCard";
import TripUpgradeBox from "./TripUpgradeBox";

interface IComponent {
  journey: Journey;
}

interface DetailsViewLocationState {
  showAirPayoutSubscriptionModal: boolean;
  userDidNotSelectAirLuggage: boolean;
}

const DetailsView: React.FC<IComponent> = ({ journey }) => {
  const location = useLocation();

  const state = location.state as DetailsViewLocationState;
  const showAirPayoutSubscriptionModal = !!(state && state.showAirPayoutSubscriptionModal);
  const userDidNotSelectAirLuggage = !!(state && state.userDidNotSelectAirLuggage);

  return (
    <Box width="100%" data-testid={`journey-${journey.id}`}>
      {/* trip essential to complete */}
      {journey?.trip && journey?.trip?.upgradeable ? (
        <Box my={4}>
          <TripUpgradeBox tripUuid={journey.trip.uuid} />
        </Box>
      ) : null}
      <Box flexDirection="column">
        <TripCard
          key={journey.id}
          journey={journey}
          showAirPayoutSubscriptionModal={showAirPayoutSubscriptionModal}
          userDidNotSelectAirLuggage={userDidNotSelectAirLuggage}
        />
      </Box>
    </Box>
  );
};

export default DetailsView;
